import React, { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE } from "../../../constants/driveglobalfilterinitialstates_coral";
// import { INIT_FILTER_STATE_DRIVE_ACE } from "../../../constants/driveglobalfilterinitalstates";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_coral";
import useHttp from "../../../hook/use-http";
import Filter_Jupiter from "./Filter_Jupiter";
import Topkpis_Jupiter from "./Topkpis_Jupiter";
import PageSecond_Jupiter from "./PageSecond_Jupiter";
import TwoChartTemplate_Jupiter from "./TwoChartTemplate_Jupiter";
import SingleSoc_Jupiter from "./SingleSoc_Jupiter";
import SinglePie_Jupiter from "./SinglePie_Jupiter";
import DischargeDuration_Jupiter from "./DischargeDuration_Jupiter";
import RpmVsThrottle_Jupiter from "./RpmVsThrottle_Jupiter";
import RegenPercent_Jupiter from "./RegenPercent_Jupiter";
import IdlePercent_Jupiter from "./IdlePercent_Jupiter";
import BcsActiveTime_Jupiter from "./BcsActiveTime_Jupiter";
import DashboardMain_Jupiter from "../DashboardMain_Jupiter/DashboardMain_Jupiter";
import "./Driveanalysis_Jupiter.css";
import WaterMark from "../DashboardMain_Jupiter/WaterMark";
import AppContext from "../../../store/AppContext";

import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import TableSection_Jupiter from "./TableSection_Jupiter";
import NetEnergyErc_Jupiter from "./NetEnergyErc_Jupiter";
import RangeErc_Jupiter from "./RangeErc_Jupiter";
import SingleSocErc_Jupiter from "./SingleSocErc_Jupiter";
import PageSecondErc_Jupiter from "./SecondPageErc_Jupiter/PageSecondErc_Jupiter";
import PieChartSocErc_Jupiter from "./RegenModeUsage";


function Driveanalysis_Jupiter() {
  const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE);
  // const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE_DRIVE_ACE);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);

  const log_data = (data) => { };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "auth/logging",
        body: {
          page_name: "driveanalysis",
        },
      },
      log_data
    );
  }, []);

  const filterSubmited = useCallback((data) => {
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setGloablfilter((prevdata) => {
      return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 };
    });
  };

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] };
    });
  };

  const onreset = (data) => {
    setGloablfilter(data);
  };

  const loggedInUser = useSelector(selectLoggedInUser);
  if (gloablfilter.pageSelected === 1) {
    return (
      <>
        <DashboardMain_Jupiter>
          <div
            className={
              (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                ? "new_drive_dashboard"
                : "drive_dashboard"
            }
          >
            <Filter_Jupiter
              onsubmit={filterSubmited}
              gloablfilter={gloablfilter}
              onreset={onreset}
            />
            <div className="container-fluid">
              <Topkpis_Jupiter gloablfilter={gloablfilter} />
              {(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                <TableSection_Jupiter
                  singleVinSelected={singleVinSelected}
                  gloablfilter={gloablfilter}
                />
              )}
              <section className="graphs">
                <div className="row">
                  {/* {loggedInUser.flagForHideShow === "ERC" && (
                    <div className="col-md-12 col-sm-12 col-lg-3 mb-3">
                      <div id="wrapper" className="toggled">
                        <div id="page-content-wrapper">
                          <TopFiveSection
                            singleVinSelected={singleVinSelected}
                            gloablfilter={gloablfilter}
                          ></TopFiveSection>
                        </div>
                      </div>
                    </div>
                  )} */}
                  <div
                    className={
                      "col-md-12 col-sm-12 " +
                      ((loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                        ? "col-lg-12"
                        : "col-lg-12")
                    }
                  >
                    <div className="row mb-3">
                      {!(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                        <>
                          <div className="col-md-12 col-sm-12 col-lg-6">
                            <TwoChartTemplate_Jupiter
                              title="Real World Range Distribution"
                              type="RANGE"
                              gloablfilter={gloablfilter}
                            ></TwoChartTemplate_Jupiter>
                          </div>
                          <div className="col-md-12 col-sm-12 col-lg-6">
                            <TwoChartTemplate_Jupiter
                              title="Net Energy consumption"
                              type="ENERGY"
                              gloablfilter={gloablfilter}
                            ></TwoChartTemplate_Jupiter>
                          </div>
                        </>
                      )}

                      {(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                        <>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph ">
                            <WaterMark />
                            <RangeErc_Jupiter
                              title="Real World Range Distribution"
                              gloablfilter={gloablfilter}
                              apiend="rangebarchart_erc"
                            ></RangeErc_Jupiter>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph ">
                            <WaterMark />
                            <NetEnergyErc_Jupiter
                              title="Net Energy Consumption"
                              gloablfilter={gloablfilter}
                              apiend="energybarchart_erc"
                            ></NetEnergyErc_Jupiter>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph ">
                            <WaterMark />
                            <SingleSocErc_Jupiter
                              title="SoC Discharge/Cycle "
                              gloablfilter={gloablfilter}
                              apiend="socbar_erc"
                            ></SingleSocErc_Jupiter>
                          </div>

                        </>
                      )}
                    </div>

                    <div className="row mb-3 equal-cols">
                      {!(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                        <>
                          <div className="col-md-6 col-sm-12 col-lg-6 drive_graph">
                            <WaterMark />
                            <SingleSoc_Jupiter
                              title="SoC Discharge/Cycle Analysis"
                              gloablfilter={gloablfilter}
                              apiend="socbar"
                            ></SingleSoc_Jupiter>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-6">
                            <WaterMark />
                            <SinglePie_Jupiter
                              title="Mode utilization"
                              gloablfilter={gloablfilter}
                              apiend="piechart"
                            ></SinglePie_Jupiter>
                          </div>
                        </>
                      )}
                      {(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                        <>
                          <div className="col-md-6 col-sm-12 col-lg-4  drive_graph mt-2 mb-2">
                            <WaterMark />
                            <RpmVsThrottle_Jupiter
                              title="Median RPM vs Median Throttle"
                              gloablfilter={gloablfilter}
                              apiend="rpm_vs_throttle_erc"
                            ></RpmVsThrottle_Jupiter>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph mt-2">
                            <WaterMark />
                            <RegenPercent_Jupiter
                              title="Median Regen Percent"
                              gloablfilter={gloablfilter}
                              apiend="regenbar"
                            ></RegenPercent_Jupiter>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph mt-2">
                            <WaterMark />
                            <IdlePercent_Jupiter
                              title="Median Idle Percent"
                              gloablfilter={gloablfilter}
                              apiend="idlebar"
                            ></IdlePercent_Jupiter>
                          </div>
                        </>
                      )}
                      {/* <div
                        className={
                          loggedInUser.flagForHideShow === "ERC"
                            ? "col-md-6 col-sm-4 col-lg-3 pr-1"
                            : "col-md-6 col-sm-6"
                        }
                      >
                        <WaterMark />
                        <SingleSoc
                          title="SoC Discharge/Cycle Analysis"
                          gloablfilter={gloablfilter}
                          apiend="socbar"
                        ></SingleSoc>
                      </div> */}
                      {/* <div
                        className={
                          loggedInUser.flagForHideShow === "ERC"
                            ? "col-md-6 col-sm-4 col-lg-3 pr-1"
                            : "col-md-6 col-sm-6"
                        }
                      >
                        <WaterMark />
                        <SinglePie
                          title="Mode utilization"
                          gloablfilter={gloablfilter}
                          apiend="piechart"
                        ></SinglePie>
                      </div> */}
                      {(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                        <>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph mt-3">
                            <WaterMark />
                            <BcsActiveTime_Jupiter
                              title="Median BCS Active Time"
                              gloablfilter={gloablfilter}
                              apiend="bcs_activebar"
                            ></BcsActiveTime_Jupiter>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph mt-3">
                            <WaterMark />
                            <DischargeDuration_Jupiter
                              title="Median Dishcharge Duration"
                              gloablfilter={gloablfilter}
                              apiend="discharge_bar"
                            ></DischargeDuration_Jupiter>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph mt-3">
                            <WaterMark />
                            <PieChartSocErc_Jupiter
                              title="Regen Mode Usage"
                              gloablfilter={gloablfilter}
                              apiend="regen_modes_pie"
                            ></PieChartSocErc_Jupiter>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </DashboardMain_Jupiter>
      </>
    );
  } else {
    return (
      <DashboardMain_Jupiter>
        {!(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") ? (
          <PageSecond_Jupiter gloablfilter={gloablfilter} pageChange={pageChange} />
        ) : (
          <div className="new_drive_dashboard">
            <PageSecondErc_Jupiter
              gloablfilter={gloablfilter}
              pageChange={pageChange}
            />
          </div>
        )}
      </DashboardMain_Jupiter>
    );
  }
}

export default Driveanalysis_Jupiter;
